import MajorEventsLanding from './major-events-landing'
import MajorEventsLandingQuery, { MAJOR_EVENTS_LANDING_QUERY } from './major-events-landing.query'

export { MajorEventsLandingQuery, MAJOR_EVENTS_LANDING_QUERY }

export default MajorEventsLanding
